import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { useLanguage } from './LanguageContext';
import { Layers, Target, RefreshCw, Zap } from 'lucide-react';
interface SlideStrategyProps {
  onContinue: () => void;
}
export function SlideStrategy({
  onContinue
}: SlideStrategyProps) {
  const {
    t
  } = useLanguage();
  const [stage, setStage] = useState(0);
  const pillars = [{
    title: t('Leverage Existing Assets', 'Udnyt eksisterende aktiver'),
    desc: t('No new content creation required. We repurpose existing approved materials into interactive formats.', 'Ingen behov for skabelse af nyt indhold. Vi genbruger eksisterende godkendte materialer i interaktive formater.'),
    icon: <Layers className="w-6 h-6 text-teal-400" data-id="element-828" />
  }, {
    title: t('Rapid Deployment', 'Hurtig udrulning'),
    desc: t('Centralized creation with localized distribution. Campaigns go live in days, not months.', 'Centraliseret skabelse med lokaliseret distribution. Kampagner går live på dage, ikke måneder.'),
    icon: <Zap className="w-6 h-6 text-purple-400" data-id="element-829" />
  }, {
    title: t('Behavioral Data Capture', 'Indsamling af adfærdsdata'),
    desc: t('Moving beyond vanity metrics to reveal what actually drives HCP decisions.', 'Vi går ud over forfængelighedsmetrikker for at afsløre, hvad der rent faktisk driver HCP-beslutninger.'),
    icon: <Target className="w-6 h-6 text-rose-400" data-id="element-830" />
  }, {
    title: t('Continuous Optimization', 'Kontinuerlig optimering'),
    desc: t('Every interaction informs and improves the next campaign in a closed-loop system.', 'Hver interaktion informerer og forbedrer den næste kampagne i et lukket system.'),
    icon: <RefreshCw className="w-6 h-6 text-sky-400" data-id="element-831" />
  }];
  useEffect(() => {
    const timers = pillars.map((_, idx) => setTimeout(() => setStage(idx), 500 + idx * 400));
    return () => timers.forEach(clearTimeout);
  }, []);
  return <div className="h-full w-full flex flex-col px-12 py-16 md:px-24 md:py-20 max-w-7xl mx-auto" data-id="element-832">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-center space-y-4" data-id="element-833">
        <h2 className="text-4xl md:text-5xl font-serif text-white" data-id="element-834">
          {t('The Operating Model', 'Driftsmodellen')}
        </h2>
        <p className="text-xl text-white/60" data-id="element-835">
          {t('Built for scale, speed, and continuous learning.', 'Bygget til skalering, hastighed og kontinuerlig læring.')}
        </p>
      </motion.div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-8 items-center justify-center max-w-5xl mx-auto w-full" data-id="element-836">
        {pillars.map((pillar, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= idx ? 1 : 0,
        y: stage >= idx ? 0 : 20
      }} className="bg-navy-700/40 border border-navy-600 p-8 rounded-2xl h-full flex flex-col" data-id="element-837">
            <div className="w-12 h-12 rounded-xl bg-teal-400/10 text-teal-400 flex items-center justify-center mb-6" data-id="element-838">
              {pillar.icon}
            </div>
            <h3 className="text-xl font-semibold text-white mb-3" data-id="element-839">
              {pillar.title}
            </h3>
            <p className="text-white/60 leading-relaxed flex-1" data-id="element-840">
              {pillar.desc}
            </p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 5 ? 1 : 0
    }} className="mt-12 flex justify-center" data-id="element-841">
        <Button onClick={onContinue} data-id="element-842">
          {t('What Snakker Does', 'Hvad Snakker gør')}
        </Button>
      </motion.div>
    </div>;
}